import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {Provider} from 'react-redux';
import {syncHistoryWithStore} from 'react-router-redux';
import {Router, Route, IndexRoute, browserHistory} from 'react-router';
import store from 'store';
import KitController from '../components/KitController';
import NotFoundController from '../components/NotFoundController';
import SummaryController from '../components/SummaryController';
import MigrateController from '../components/MigrateController';
import IconsController from '../components/IconsController';
import TypefacesController from '../components/TypefacesController';
import ImagesController from '../components/ImagesController';
import DocumentationController from '../components/DocumentationController';
import DocumentationSummaryController from '../components/DocumentationSummaryController';
import DocumentationIconsController from '../components/DocumentationIconsController';
import DocumentationTypefacesController from '../components/DocumentationTypefacesController';
import DocumentationImagesController from '../components/DocumentationImagesController';
import UploadLogoController from '../components/UploadLogoController';
import AddIconsController from '../components/AddIconsController';
import UploadIconController from '../components/UploadIconController';
import EditIconController from '../components/EditIconController';
import AddTypefaceController from '../components/AddTypefaceController';
import UploadTypefaceController from '../components/UploadTypefaceController';
import EditTypefaceController from '../components/EditTypefaceController';
import UploadImageController from '../components/UploadImageController';
import EditImageController from '../components/EditImageController';

const KitIntegrator = createReactClass({
  propTypes: {
    iconsSearchIndexName: PropTypes.string.isRequired,
  },

  childContextTypes: {
    iconsSearchIndexName: PropTypes.string,
  },

  getChildContext() {
    return {
      iconsSearchIndexName: this.props.iconsSearchIndexName,
    };
  },

  render() {
    return (
      <Provider store={store}>
        <Router history={syncHistoryWithStore(browserHistory, store)}>
          <Route path="/kits/:kitToken/migrate" component={MigrateController} />
          <Route path="/kits/:kitToken" component={KitController}>
            <IndexRoute component={SummaryController} />
            <Route path="icons" component={IconsController} />
            <Route path="typefaces" component={TypefacesController} />
            <Route path="images" component={ImagesController} />
            <Route path="docs" component={DocumentationController}>
              <IndexRoute component={DocumentationSummaryController} />
              <Route path="icons" component={DocumentationIconsController} />
              <Route path="typefaces" component={DocumentationTypefacesController} />
              <Route path="images" component={DocumentationImagesController} />
            </Route>
          </Route>
          <Route path="/kits/:kitToken/logo/upload" component={UploadLogoController} />
          <Route path="/kits/:kitToken/icons/new" component={AddIconsController} />
          <Route path="/kits/:kitToken/icons/upload" component={UploadIconController} />
          <Route path="/kits/:kitToken/icons/:workingSetIconId" component={EditIconController} />
          <Route path="/kits/:kitToken/typefaces/new" component={AddTypefaceController} />
          <Route path="/kits/:kitToken/typefaces/upload" component={UploadTypefaceController} />
          <Route path="/kits/:kitToken/typefaces/:workingSetTypefaceId" component={EditTypefaceController} />
          <Route path="/kits/:kitToken/images/upload" component={UploadImageController} />
          <Route path="/kits/:kitToken/images/:workingSetImageId" component={EditImageController} />
          <Route path="/kits/:kitToken/*" component={NotFoundController} />
        </Router>
      </Provider>
    );
  },
});

export default (props) => {
  /* eslint-disable react/prop-types */
  return <KitIntegrator iconsSearchIndexName={props.icons_search_index_name} />;
  /* eslint-enable react/prop-types */
};



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/integrators/KitIntegrator.js